import React, { useState, useEffect, useContext, useRef } from 'react'
import StockOutHeader from './StockOutHeader'
import StockOutInner from './StockOutInner'
import StockOutFooter from './StockOutFooter'
import { appContext } from '../../../App'
import { dateYMD, isObjEmpty } from '../../utilities/utilities'
import { getWarehouses, getStockOutList, getProductsList,
  saveStockOut, deleteStockOut } from '../StockOutFunctions'

export const stockOutControllerContext = React.createContext()

function useStockOutController(props) {
  const app = useContext(appContext)
  const { getClientDateTime }  = app

  const initStockOut = {
    status: 'On Process',
    date_released: dateYMD(new Date(getClientDateTime())),
    source_warehouse: { name: '',  id: null },
    dest_warehouse: { name: '', id: null},
    si_received_by: '',
    prepared_by: '',
    reference_code: '',
    remarks: '',
    item_details: []
  }

  const initStockOutItemDetail = {
    id: '',
    name: '',
    unit: '',
    quantity: 1,
    remarks: '',
    expiration_date: ''
  }

  const [stockOut, setStockOut] = useState(null)
  const [warehouses, setWarehouses] = useState(null)
  const [stockOutItemDetail, setStockOutItemDetail] = useState(initStockOutItemDetail)
  const [stockOutList, setStockOutList] = useState([])
  const [productsList, setProductsList] = useState([])
  const refStockOut = useRef(null)

  const resetStockOutItemDetail = () => setStockOutItemDetail(initStockOutItemDetail)
  
  useEffect(() => {
    const init = async () => {
      const stockout_list = await getStockOutList(app)
      setStockOutList(stockout_list)

      const products_list = await getProductsList(app)
      setProductsList(products_list.map(product => (
        {
          item_id: product._id,
          item_units: product.units,
          item_full_description: `${product.brand} ${product.name} ${product.description}`
        }
      )))

      const warehouses = await getWarehouses(app)
      if (warehouses) {
        setWarehouses(warehouses)
        const so = (
          isObjEmpty(props)
          ? {
              ...initStockOut,
              source_warehouse: { name: warehouses[0].name, id: warehouses[0]._id },
              dest_warehouse: { name: '--None--', id: null }
            }
          : props.stockOutItem
        )
        setStockOut({
          ...so,
          date_released: dateYMD(new Date(so.date_released))
        })
      }
    }

    init()

    /** Unmounting */
    return(async () => {
      const stock_out = refStockOut.current
      if (stock_out.item_details.length === 0)
        await deleteStockOut(app, stock_out._id)
      else if (stock_out.status === "On Process") {
        stock_out.status = 'Unposted'
        await saveStockOut(app, stock_out)
      }
    })
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const autoSaveStockOut = async () => {
      if (stockOut._id) { // update
        if (stockOut.new) delete stockOut.new
        else {
          refStockOut.current = stockOut
          await saveStockOut(app, stockOut, true) 
        }
      } else { // new
        // Just get and set the new so id generetad
        const stock_out = await saveStockOut(app, stockOut)
        refStockOut.current = stock_out
        stock_out.new = true
        stock_out.date_released = dateYMD(new Date(stock_out.date_released))
        setStockOut(stock_out)
      }
    }

    if (stockOut) autoSaveStockOut()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockOut])

  const obj = {
    stockOut: [stockOut, setStockOut],
    stockOutItemDetail: [stockOutItemDetail, setStockOutItemDetail, resetStockOutItemDetail],
    saveStockOut,
    deleteStockOut,
    stockOutList: stockOutList,
    productsList: productsList,
    warehouses,
    refStockOut
  }

  return (obj)
}

function StockOutController(props) {
  const stockOutController = useStockOutController(props)
  if (stockOutController.stockOut[0]) { // Ensures that the SO to render is no null
    return (
      <React.Fragment>
        <stockOutControllerContext.Provider value={stockOutController}>
          <StockOutHeader />
          <StockOutInner />
          <StockOutFooter />
        </stockOutControllerContext.Provider>
      </React.Fragment>
    )
  } else return (null)
}

export default React.memo(StockOutController)